<template>
    <div class="cp-store-locator__list" :style="{'height': height}">
        <ul class="cp-store-locator__list__stores">
            <li
                :class="['cp-store-locator__list__stores__el', {active: isActive === store.uid}]"
                @click.stop.prevent="clickCenterStore(store)"
                @mouseover="onMouseOver(store)"
                @mouseout="onMouseOut"
                :id="store.uid"
                :key="store.uid"
                v-for="store in stores"
            >
                <p class="h3">{{ store.name }}</p>

                <p class="h4" v-html="store.excerpt"></p>

                <p>
                    <span v-for="(name, slug) in store.categories" @click.prevent="" class="cp-store-locator__list__stores__el__category">{{ name }}</span>
                </p>

                <p>
                    {{ store.address_1 }}<br v-if="store.address_1 !== ''">
                    {{ store.address_2 }}<br v-if="store.address_2 !== ''">
                    {{ store.address_3 }}<br v-if="store.address_3 !== ''">
                    {{ store.contact }}<br>
                    <button @click.stop.prevent="clickStore(store)">{{ labels.more_info }}</button>
                </p>
            </li>

        </ul>
    </div>
</template>

<script>
export default {
    name: "cp-store-locator-list",
    props: {
        stores: {
            type: Array,
            default() {
                return [];
            },
        },

        labels: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            height: 0,
            isActive: null,
        };
    },
    methods: {
        activeStore(uid) {
            this.isActive = uid;
        },

        clickCenterStore(store) {
            this.$events.emit('center-map', store.lat, store.lng, 11);
            this.$events.emit('disable-marker');
        },

        clickStore(store) {
            this.$events.emit('center-map', store.lat, store.lng, 15);
            this.$events.emit('disable-marker');
            this.$events.emit('active-marker', store.uid);
        },

        onMouseOver(store) {
            this.$events.emit('create-circle', store.lat, store.lng, 15000);
        },

        onMouseOut() {
            this.$events.emit('clear-circle');
        },

        computedHeight()
        {
            const maxHeight = 765;
            const searchHeight = document.querySelector('.cp-store-locator__search').getBoundingClientRect().height;

            return ( maxHeight - searchHeight ) + 'px';
        }
    },
    mounted() {
        this.$events.on('active-marker', uid => this.activeStore( uid ) );
        this.$events.on('disable-marker', () => this.isActive = null );

        this.height = this.computedHeight();
    },
}
</script>
